module.exports = __webpack_public_path__ + "img/baseline-pavilion.2ccbf821.svg";